import { NavLink } from "react-router-dom";
import Icon from "../components/Icon";
import AccountNavButton from "./AccountNavButton";
import CarSwitcher from "./CarSwitcher";

/**
 * Desktop sidebar (hidden on small screens via existing CSS). Mirrors the
 * structure of the legacy base.html sidebar exactly so the existing CSS
 * classes apply unchanged.
 */
export default function Sidebar() {
  return (
    <aside className="app-sidebar" aria-label="Primary">
      <NavLink to="/" className="app-sidebar__brand" end>
        <Icon name="fuel" className="app-sidebar__logo" />
        <span>wasschluckter</span>
      </NavLink>

      <nav className="app-sidebar__nav">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            "nav-item" + (isActive ? " nav-item--active" : "")
          }
        >
          <Icon name="fuel" className="nav-item__icon" />
          <span className="nav-item__label">Overview</span>
        </NavLink>
        <NavLink
          to="/history"
          className={({ isActive }) =>
            "nav-item" + (isActive ? " nav-item--active" : "")
          }
        >
          <Icon name="clock" className="nav-item__icon" />
          <span className="nav-item__label">History</span>
        </NavLink>
        <NavLink
          to="/analysis"
          className={({ isActive }) =>
            "nav-item" + (isActive ? " nav-item--active" : "")
          }
        >
          <Icon name="chart" className="nav-item__icon" />
          <span className="nav-item__label">Analysis</span>
        </NavLink>
      </nav>

      <div className="app-sidebar__footer">
        <CarSwitcher variant="wide" placement="up" />
        <AccountNavButton variant="wide" />
      </div>
    </aside>
  );
}
